export enum PaymentFrequency {
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  ANNUALLY = 'Annually',
  ONE_TIME = 'One-Time'
}

export enum LegacyArchiveReason {
  HISTORICAL_DUPLICATE = 'Historical Duplicate',
  MIGRATION_RECONCILIATION = 'Migration Reconciliation',
  CREATED_IN_ERROR = 'Created In Error'
}

export enum DisconnectedReason {
  INACTIVE_LEGACY_ORDER = 'Inactive Legacy Order',
  INQUIRY_RESPONSE = 'Inquiry Response',
  MOVED_OR_CLOSED_LOCATION = 'Moved or Closed Location',
  CHANGE_IN_SUPPLIER = 'Change in Supplier',
  CHANGE_IN_TECHNOLOGY = 'Change in Technology',
  UNKNOWN = 'Unknown',
  BANKRUPTCY = 'Bankruptcy',
  TSD_SUPPLIER_NOTIFICATION = 'TSD/Supplier Notification',
  CUSTOMER_NON_PAYMENT = 'Customer Non-Payment',
  MISSED_RENEWAL = 'Missed Renewal',
  DEAL_REGISTRATION_DENIED = 'Deal Registration Denied',
  SERVICE_CHANGE = 'Service Change',
  CUSTOMER_REQUEST = 'Customer Request',
  DECOMMISSIONED_BY_COMMISSIONS = 'Decommissioned by Commissions'
}

export const CommissionsValidationsSubStatusOptions = [
  null,
  'CIE Reduction',
  'Non-Commissionable Components',
  'Out of Term',
  'Single RPM Acct w/Multi SR',
  'Usage',
  'Variable Commissions',
  'Currency Conversion',
  'Commission Ineligible'
];

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const usaCurrency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
export const booleanFields = ['proactive', 'active', 'blendedRate', 'reviewRequired'];
export const doublewideFields = ['notesToCommissions', 'description'];
